import React, { Component } from 'react'
import { graphql } from 'gatsby'
import he from 'he'
import Link from '../utils/link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { navigate } from "gatsby"

//import SmoothScroll from "../components/SmoothScroll/SmoothScroll";

import Slide from 'react-reveal/Slide';
import Seo from '../components/seo'

import RenderProjectBlock from '../utils/render-project-block'

class ArticleTemplate extends Component { 
  timer = null;

  state = {
    scrolled: false,
    nextProject: false,
  }

  componentDidMount() {
    window && window.addEventListener('scroll', this.scrollDetect)
  }

  componentWillUnmount() {
    window && window.removeEventListener('scroll', this.scrollDetect)
    clearTimeout(this.timer);
  }

  toggleScrolled = () => {
    this.setState({ scrolled: !this.state.scrolled })
  }


  sendLink = () => {
    let link = document.getElementById('Newpage');
    this.timer = setTimeout(() =>  link.click(), 200);
  }
  

  onScroll = (e) => {
    let scrolled = window.scrollY > 250
    // let scrolled = window.scrollY > 1500
    if (scrolled !== this.state.scrolled) {
      requestAnimationFrame(this.toggleScrolled)
    }

    const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    const windowBottom = windowHeight + window.pageYOffset;
    // const userScrollDistance = window.scrollY;

    // console.log(window.scrollY);
    // console.log(windowBottom);
    // console.log(docHeight);

  
    let nextImage = document.getElementById('nextImage');

    if (windowBottom >= docHeight - 200) {
       nextImage.classList.add('slide-up');
    } else {
      nextImage.classList.remove('slide-up');
    }

    if (window.scrollY >= 150) {
      if (windowBottom >= docHeight - 10) {
        // console.log('bottom reached');

        // load next project
        let link = document.getElementById('Newpage');
        // let nextImage = document.getElementById('nextImage');

        // nextImage.classList.add('slide-up');
        if(link) {

          clearTimeout(this.timer);
          this.sendLink();
          //console.log(this.timer);

          // setTimeout(function() {
          //   //link.click();
          // }, 500);
        }

      } else {
          // console.log('not at bottom');
      }
    }
  }



  scrollDetect = () => {
    window && window.clearTimeout( this.isScrolling )
    this.isScrolling = setTimeout(this.onScroll, 0);
  }

  render() {

    let { scrolled } = this.state

    let project = this.props.data.wpProject
    let currentID = this.props.data.wpProject.id
    let projects = this.props.data.allWpProject.edges
//    let page = this.props.data.wpPage

    // { console.log(projects) }
    // { console.log(currentID) }

    function search(nameKey, myArray){
      for (var i=0; i < myArray.length; i++) {

        // console.log(myArray[i]);

         if(myArray[i].previous) {
          if (myArray[i].previous.id === nameKey) {
            let current = i+1 ;
//          let next = myArray[current].next.uri;

            if(myArray[current] == null) {

            } else {
              let next = myArray[current].previous;

              //console.log(next);
              return next;
            }
          }
         }
      }
    }
    // Returned next post after current

    let resultObject = search(currentID, projects);
    // console.log(projects);
    // console.log(currentID);
    let scrolledClass = 'project'
    if (scrolled) scrolledClass += ' page--scrolled'


    const featuredImageData = project.acf.mainLandscapeImage;
    const baseURL = "https://studiosmall.com";
    const imageURL = featuredImageData.localFile.childImageSharp.original.src;
    const fullImageURL = baseURL + imageURL;

    return (
      <>

        {/* <Seo
          title={he.decode(project.seo.title)}
          path={`/project/${project.slug}/`}
          bodyClass='single-project' 
          description={project.seo.metaDesc}
          keywords={project.seo.metaKeywords}
          schema={project.seo.schema.raw}
          src={project.acf.mainLandscapeImage?.sourceUrl}
        /> */}

        <Seo
          bodyClass='single-project'
          title={project.title}
          description={project.acf.description}
          path={`/project/${project.slug}/`}
          metaDescPost={project.acf.description}
          // imagePost={imageUrl ? getImage(featuredImage) : null}
          imagePost={fullImageURL}
          {...project.seo}
        />

        {/* {console.log(fullImageURL)} */}

        {/* {typeof window !== 'undefined' && (

          <SmoothScroll> */}

          <section className={scrolledClass}>
            <div className='project__inner'>
              <div className='title-container'>


                <div className={'title-container__inner ' + project.acf.projectTitleColour}>
                  <h1>{he.decode(project.title)}</h1>

                  <div className='title-container__category'>
                    { project.categories?.nodes.map((item, cat) => (
                      <span key={cat}>{item.name}</span>
                    )) }
                  </div>
                </div>
              </div>

            { project.acf.mainLandscapeImage &&
              <Slide bottom>
                <section className='project-landscape'>
                  <div className='desktop'>
                    <GatsbyImage className='project-landscape__bg' image={getImage(project.acf.mainLandscapeImage?.localFile)} alt={he.decode(project.seo.title)} />
                  </div>
                </section>
              </Slide>
            }

            { project.acf.layoutBlocks && project.acf.layoutBlocks.map((el, i) => RenderProjectBlock(el.fieldGroupName, el, i, 'project'))  }

              <section className='project-details'>

                <div className='project-details__details'>
                  <div className='project-details__details--inner'>
                    <div className='project-details__row'>
                      {/* <Slide bottom> */}
                      <div className='project-details__row--item'>
                        <div className='project-details__title-bottom'>
                          <h3>{he.decode(project.title)}</h3>
                          <span className='project-details__cat'>
                            { project.categories?.nodes.map((it, item) => (
                              <span key={item} >{it.name}</span>
                            )) }
                          </span>

                        </div>

                        <div dangerouslySetInnerHTML={{ __html: project.acf.description }} />

                      </div>
                      {/* </Slide> */}
                    </div>

                    { resultObject &&
                    <Slide bottom>
                      <div className='project-details__footer'>
                        <Link to={resultObject.uri}>View Next Project</Link>

                        <div className='project-details__next'>
                        <Link to={resultObject.uri}><h4>{ resultObject.title }</h4></Link>
                          <div className='project-details__category'>
                            { resultObject.categories?.nodes.map((it, key) => (
                              <span key={key} >{it.name}</span>
                            )) }
                          </div>
                        </div>
                      </div>
                    </Slide>
                    }
                  </div>
                </div>
                </section>

              </div>

            { resultObject &&
              <>
                <div className="arrow__container">
                  <div className='sticky'>
                    {/* <Slide bottom delay={500}> */}
                      <div className='project__nextArrow'>

                        {/* <button id='Newpage' ref={resultObject.uri} onClick={()=>{navigate(resultObject.uri)}}>Next</button> */}
                        <button id='Newpage' ref={resultObject.uri} onClick={()=>{navigate(resultObject.uri)}}>Next</button>

                        <Link  className='theLink' to={resultObject.uri}>
                          <svg width="24" height="36" viewBox="0 0 24 36" fill="none">
                            <path d="M12 0V35M12 35L1 23.7654M12 35L23 23.7654" stroke="black"/>
                          </svg>
                        </Link>
                      </div>
                    {/* </Slide> */}
                  </div>
                </div>


                <div className="project__nextCover">
                  <div id='nextImage' className='project__nextCover--container'>
                    <GatsbyImage className='project__nextCover--bg' loading='lazy' image={getImage(resultObject.acf.mainLandscapeImage?.localFile)} alt='StudioSmall' />
                  </div>
                </div>
              </>
            }

            </section>
          {/* </SmoothScroll>

            )} */}
      </>
    )
  }
}

export const pageQuery = graphql`
  query ($id: String!) {
    allWpProject(sort: {date: DESC}) {
      edges {
        previous {
          id
          title
          uri
          date(formatString: "DD MMMM, YYYY")
          categories {
            nodes {
              id
              name
            }
          }
          acf {
            mainLandscapeImage {
              sourceUrl
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 100
                    width: 2880
                    formats: [AUTO, WEBP]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
          }
        }
      }
    }
    wpProject(id: {eq: $id}) {
      id
      title
      date(formatString: "MMMM Do YYYY")
      slug
      seo {
        ...WpSeo
      }
      categories {
        nodes {
          name
        }
      }
      seo {
        title
        metaDesc
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          localFile {
            childImageSharp {
              original {
                src
                width
                height
              }
            }
          }
        }
        schema {
          raw
        }
      }
      acf {
        projectTitleColour
        description
        mainLandscapeImage {
          sourceUrl
          localFile {
            childImageSharp {
              original {
                src
              }
              gatsbyImageData(
                quality: 100
                width: 2880
                formats: [AUTO, WEBP]
                placeholder: DOMINANT_COLOR
              )
            }
          }
        }
        featured {
          localFile {
            childImageSharp {
              gatsbyImageData(
                quality: 100
                width: 900
                formats: [AUTO, WEBP]
                placeholder: DOMINANT_COLOR
              )
            }
          }
        }
        layoutBlocks {
          ... on WpProject_Acf_LayoutBlocks_ProjectLandscapeImage {
            fieldGroupName
            bgcolour
            landscapeImage {
              title
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 100
                    width: 2880
                    formats: [AUTO, WEBP]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
          }
          ... on WpProject_Acf_LayoutBlocks_ProjectContainedLandscapeImage {
            bgcolour
            fieldGroupName
            landscapeImage {
              title
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 100
                    width: 2880
                    formats: [AUTO, WEBP]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
          }
          ... on WpProject_Acf_LayoutBlocks_ProjectLandscapeGifImage {
            fieldGroupName
            imageContainer
            bgcolour
            gifLandscapeImage {
              sourceUrl
            }
          }
          ... on WpProject_Acf_LayoutBlocks_ProjectPortraitImages {
            fieldGroupName
            imageTypeFirst
            imageTypeSecond
            portrait {
              title
              altText
              sourceUrl
              localFile {
                uid
                childImageSharp {
                  gatsbyImageData(
                    quality: 100
                    width: 1800
                    formats: [AUTO, WEBP]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
            portraitSecond {
              title
              altText
              sourceUrl
              localFile {
                uid
                childImageSharp {
                  gatsbyImageData(
                    quality: 100
                    width: 1800
                    formats: [AUTO, WEBP]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
          }
          ... on WpProject_Acf_LayoutBlocks_ProjectContainedPortraitImages {
            fieldGroupName
            bgcolour
            imageContainedRight
            imageContainedLeft
            imageTypeFirst
            imageTypeSecond
            portrait {
              title
              altText
              sourceUrl
              localFile {
                uid
                childImageSharp {
                  gatsbyImageData(
                    quality: 100
                    width: 1800
                    formats: [AUTO, WEBP]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
            portraitSecond {
              title
              altText
              sourceUrl
              localFile {
                uid
                childImageSharp {
                  gatsbyImageData(
                    quality: 100
                    width: 1800
                    formats: [AUTO, WEBP]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
          }
          ... on WpProject_Acf_LayoutBlocks_VimeoVideo {
            fieldGroupName
            vimeoVideoId
            fullwidthVideo
            squareRatioVideo
            backgroundcol
          }
          ... on WpProject_Acf_LayoutBlocks_VimeoVideoAutoplay {
            fieldGroupName
            fullwidth
            vimeoVideoId
            bgc
          }
        }
      }
    }
  }
`

export default ArticleTemplate
